
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pix",
      function () {
        return require("private-next-pages/pix/index.js");
      }
    ]);
  